<template>
  <div class="basic_wrap">
    <h1 class="page-title">
      {{ $t("item.benefitsTitle") }}
    </h1>

    <div class="benefit-list">
      <button
        v-for="benefit in benefits"
        :key="benefit.title"
        type="button"
        class="benefit-item"
        @click="goToUpgrade(benefit.url)"
      >
        <img
          class="benefit-icon"
          :src="benefit.icon"
          alt=""
        >
        <span class="benefit-title">{{ $t(benefit.title) }}</span>
        <span class="benefit-description">{{ $t(benefit.description) }}</span>
        <span class="benefit-avatar-wrap">
          <img
            class="benefit-avatar"
            :src="benefit.avatar"
            alt=""
          >
          <i class="notification-dot" />
        </span>
        <span
          class="benefit-arrow"
          aria-hidden="true"
        />
      </button>
    </div>

    <div class="rights-list">
      <button
        v-for="right in memberRights"
        :key="right.label"
        type="button"
        class="rights-card"
        :style="{ backgroundImage: 'url(' + right.background + ')' }"
        @click="goToUpgrade(right.url)"
      >
        <span class="rights-badge">{{ $t("item.memberRights") }}</span>
        <span class="rights-label">{{ $t(right.label) }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Item",
  data() {
    const avatar = require("../images/ban5/cs.png");

    return {
      islogin: false,
      benefits: [
        {
          title: "item.memberVideo",
          url: "/vindex",
          description: "item.memberVideoDescription",
          icon: require("../images/ban5/ys1.png"),
          avatar
        },
        {
          title: "item.benefitsEntry",
		  url: "/vchoose",
          description: "item.newlyJoinedId",
          icon: require("../images/ban5/fl1.png"),
          avatar
        }
      ],
      memberRights: [{
			url: "/buy/1",
			label: "item.authenticationDataOne",
			background: require("../images/ban5/g1.png")
        },{
			url: "/buy/2",
			label: "item.authenticationDataTwo",
			background: require("../images/ban5/g2.png")
        },{
			url: "/buy/3",
			label: "item.authenticationDataThree",
			background: require("../images/ban5/g1.png")
        }
      ]
    };
  },
  created() {
    this.$parent.footer("item", true);
  },
  mounted() {
    this.islogin = localStorage.getItem("token") !== null;
    if (!this.islogin) {
      this.$router.push("/login");
    }
  },
  methods: {
    goToUpgrade(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style lang="less" scoped>
.basic_wrap {
  min-height: 100vh;
  padding: 14px 18px 66px;
  box-sizing: border-box;
  background: #faf8fc url(../images/ban5/g.png) no-repeat top center / 100% auto;
  color: #142746;
  font-family: Arial, Helvetica, sans-serif;
}

.page-title {
  margin: 0 0 16px;
  color: #000;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
}

.benefit-list,
.rights-list {
  display: flex;
  flex-direction: column;
}

.benefit-list {
  gap: 16px;
}

.benefit-item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 65px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  box-sizing: border-box;
  background: linear-gradient(100deg, #df49bc 0%, #6b37c5 100%);
  color: #fff;
  text-align: left;
}

.benefit-icon {
  flex: 0 0 auto;
  width: 29px;
  height: 29px;
  margin-right: 9px;
  object-fit: contain;
}

.benefit-title {
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
}

.benefit-description {
  min-width: 0;
  margin-left: auto;
  overflow: hidden;
  font-size: 12px;
  line-height: 17px;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.benefit-avatar-wrap {
  position: relative;
  flex: 0 0 auto;
  width: 31px;
  height: 31px;
  margin: 0 8px;
}

.benefit-avatar {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 5px;
}

.notification-dot {
  position: absolute;
  top: -3px;
  right: -3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f3192d;
}

.benefit-arrow {
  flex: 0 0 auto;
  width: 9px;
  height: 9px;
  border-top: 2px solid #171717;
  border-right: 2px solid #171717;
  transform: rotate(45deg);
}

.rights-list {
  gap: 12px;
  margin-top: 16px;
}

.rights-card {
  position: relative;
  display: block;
  width: 100%;
  height: 146px;
  padding: 0;
  overflow: hidden;
  border: 0;
  border-radius: 10px;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  color: #142746;
  text-align: left;
}

.rights-badge {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 98px;
  height: 23px;
  padding: 0 8px 0 16px;
  box-sizing: border-box;
  background: #f10d0d;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  line-height: 23px;
}

.rights-badge::before {
  position: absolute;
  top: 5px;
  left: 4px;
  width: 10px;
  height: 9px;
  content: "";
  background: linear-gradient(90deg, #fff 0 20%, transparent 20% 40%, #fff 40% 60%, transparent 60% 80%, #fff 80% 100%);
  clip-path: polygon(0 100%, 10% 20%, 27% 62%, 50% 0, 73% 62%, 90% 20%, 100% 100%);
}

.rights-label {
  position: absolute;
  top: 50%;
  left: 27px;
  transform: translateY(-50%);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

@media (max-width: 420px) {
  .basic_wrap {
    padding: 14px 18px 62px;
  }

  .benefit-item {
    min-height: 65px;
    padding: 0 12px;
  }

  .benefit-title {
    font-size: 14px;
  }

  .benefit-description {
    font-size: 12px;
  }

  .benefit-avatar-wrap {
    width: 31px;
    height: 31px;
    margin-left: 8px;
  }

  .rights-card {
    height: 146px;
  }
}
.partners-grid img{
	border-radius: 5px;
}
</style>
